import { Component, HostListener, inject } from '@angular/core';
import {
  IonRouterOutlet,
  IonHeader,
  IonToolbar,
  IonMenuButton,
  IonMenu,
  IonContent,
  IonButtons,
  IonIcon,
  MenuController,
  IonFooter,
  IonFab,
  IonFabButton,
} from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import {
  add,
  calendar,
  calendarOutline,
  cardOutline,
  close,
  cubeOutline,
  glasses,
  glassesOutline,
  grid,
  gridOutline,
  homeOutline,
  logOutOutline,
  peopleOutline,
  personOutline,
  search,
  searchOutline,
  settingsOutline,
  walletOutline,
} from 'ionicons/icons';
import { NavController } from '@ionic/angular';
import { ShortcutOverlayComponent } from '@app/app/components/shortcut-overlay/shortcut-overlay.component';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  selector: 'app-layout',
  templateUrl: './layout.page.html',
  styleUrl: './layout.page.scss',
  imports: [
    IonRouterOutlet,
    IonHeader,
    IonToolbar,
    IonMenuButton,
    IonHeader,
    IonToolbar,
    IonMenuButton,
    IonMenu,
    IonContent,
    IonButtons,
    IonIcon,
    IonFooter,
    IonFab,
    IonFabButton,
    ShortcutOverlayComponent,
    CommonModule,
  ],
})
export class LayoutPage {
  private menu = inject(MenuController);
  private router = inject(Router);
  private activeRoute = '';

  overlayOpen = false;
  windowWidth;

  @HostListener('window:resize')
  onResize() {
    this.windowWidth = window.innerWidth;
  }

  constructor(private nav: NavController) {
    addIcons({
      walletOutline,
      homeOutline,
      peopleOutline,
      cardOutline,
      cubeOutline,
      settingsOutline,
      logOutOutline,
      personOutline,
      add,
      close,
      grid,
      gridOutline,
      calendar,
      calendarOutline,
      search,
      searchOutline,
      glasses,
      glassesOutline,
    });

    this.windowWidth = window.innerWidth;
  }

  isActiveRoute(url) {
    return new RegExp(url, 'gi').test(this.router.url);
  }

  navigateTo(url) {
    this.nav.navigateForward([url]);
    this.closeMenu();
  }

  closeMenu() {
    this.menu.close('main-menu');
  }

  toggleOverlay(action?: 'customer' | 'operator' | 'expense' | 'appointment') {
    this.overlayOpen = !this.overlayOpen;
    if (action) {
      let url;
      switch (action) {
        case 'customer':
          url = 'customer/new';
          break;
        case 'operator':
          url = 'operators/new';
          break;
        case 'expense':
          url = 'expenses/new';
          break;
        case 'appointment':
          url = 'appointment/new';
          break;
        default:
          break;
      }
      if (url) {
        this.nav.navigateForward([url]);
      }
    }
  }
}
